import React from "react";
import { Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import './dataPanelTab.css';
import { CodeSquareIcon } from "@primer/octicons-react";
import FeatherIcon from 'feather-icons-react';
import { checkNowValueLessThanTolerance } from "../../mpsimCommenMethods";
import { removeGhostImage } from "../../../../../common_layouts/ghostDragWrapper";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { SyncIcon } from '@primer/octicons-react';
import { CatelogueImport } from "../../../../../masterdata/CatelogueImportLog/catelogueImportLog";
import log from "../../../../../masterdata/CatelogueImportLog/hierachyResolve/log";
import { DATA_PANEL_DATA_FIELDS, getFieldNameForCardType, hasNormalizedData, getLambdaDataValue as getSharedLambdaDataValue } from './dataPanelFilterOptions.data';
class DataPanelItemCard extends React.Component {
    constructor(props) {
        super(props)
        this._isMounted = false;
        this.state = {
            prod: this.props.prod,
            cardType: this.props.cardType,
            containerWidth: 0
        };
        this.resizeObserver = null;
    }

    componentDidMount() {
        this.initializeResizeObserver();
        // console.log('prod', this.props.prod);
        
    }

    componentWillUnmount() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }

    initializeResizeObserver = () => {
        const element = document.querySelector('.simulation-filter-section');
        if (element) {
            this.resizeObserver = new ResizeObserver(entries => {
                for (let entry of entries) {
                    if (entry.target === element) {
                        setTimeout(() => {
                            const containerWidth = entry.contentRect.width;
                            this.setState({ containerWidth });
                        }, 100);
                    }
                }
            });
            this.resizeObserver.observe(element);
        }
    }



    getBorderStyle = (prod, cardType, formValue, prodBrand, prodSubCat, prodCat, prodSup, isRTL) => {
        
        let productRedline = checkNowValueLessThanTolerance(prod?.rec?.toFixed(1), prod?.now, formValue, true);
        let brandRedline = checkNowValueLessThanTolerance(prodBrand?.brandRec, prodBrand?.brandNow, formValue, true);
        let subCatRedline = checkNowValueLessThanTolerance(prodSubCat?.subCatRec, prodSubCat?.subCatNow, formValue, true);
        let catRedline = checkNowValueLessThanTolerance(prodCat?.categoryRec, prodCat?.categoryNow, formValue, true);
        let SupplierRedline = checkNowValueLessThanTolerance(prodSup?.supplierRec, prodSup?.supplierNow, formValue, true);

        return cardType === 'product' && !productRedline ? (isRTL === "rtl" ? { borderLeft: "4px solid transparent" } : { borderRight: "4px solid transparent" })
            // : cardType === 'product' && prod.isDeletedSimProdForDataPanel ? (isRTL === "rtl" ? { borderBottom: "1px solid #EB5757" } : { border: "1px solid #EB5757" })
                : cardType === 'product' && productRedline ? (isRTL === "rtl" ? { borderLeft: "4px solid #EB5757" } : { borderRight: "4px solid #EB5757" })
                    : cardType === 'brand' && !brandRedline ? (isRTL === "rtl" ? { borderLeft: "4px solid transparent" } : { borderRight: "4px solid transparent" })
                        : cardType === 'brand' && brandRedline ? (isRTL === "rtl" ? { borderLeft: "4px solid #EB5757" } : { borderRight: "4px solid #EB5757" })
                            : cardType === 'sub-category' && !subCatRedline ? (isRTL === "rtl" ? { borderLeft: "4px solid transparent" } : { borderRight: "4px solid transparent" })
                                : cardType === 'sub-category' && subCatRedline ? (isRTL === "rtl" ? { borderLeft: "4px solid #EB5757" } : { borderRight: "4px solid #EB5757" })
                                     : cardType === 'category' && !catRedline ? (isRTL === "rtl" ? { borderLeft: "4px solid transparent" } : { borderRight: "4px solid transparent" })
                                         : cardType === 'category' && catRedline ? (isRTL === "rtl" ? { borderLeft: "4px solid #EB5757" } : { borderRight: "4px solid #EB5757" })
                                            : cardType === 'supplier' && !SupplierRedline ? (isRTL === "rtl" ? { borderLeft: "4px solid transparent" } : { borderRight: "4px solid transparent" })
                                                : cardType === 'supplier' && SupplierRedline ? (isRTL === "rtl" ? { borderLeft: "4px solid #EB5757" } : { borderRight: "4px solid #EB5757" })
                                                    : {};
    }

    getBorderBottomStyle = (prod, cardType) => {
        return prod?.category === "non-simulated" && cardType === 'product' ? { borderBottom: this.props.dmode ? "1px solid #E5E7EB" : "1px solid black" } : {}
    }

    renderNowRecValues = (nowValue, recValue) => {
        const isRTL = this.props.isRTL === "rtl";

        if (isRTL) {
            // rtl: Rec / Now
            return (
                <>
                    {recValue}
                    <span style={{ margin: '0 1px' }}>/</span>
                    {nowValue}
                </>
            );
        } else {
            // ltr: Now / Rec
            return (
                <>
                    {nowValue}
                    <span style={{ margin: '0 1px' }}>/</span>
                    {recValue}
                </>
            );
        }
    }

    handleDragEnd = () => {
        removeGhostImage();
    }

    // Get Lambda data value for a specific filter column
    getLambdaDataValue = (filter) => {
        const { prod, prodBrand, prodSubCat, prodCat, prodSup, cardType, isToggleOn, isLoadingLambdaDataPanel, toSimulateProductonly } = this.props;
        
        // Show loading icon if Lambda data is still fetching
        if (isLoadingLambdaDataPanel) {
            return <SyncIcon size={12} className="dpspinner" />;
        }
        
        // Call the shared function and get the result
        return getSharedLambdaDataValue(filter, {
            prod,
            prodBrand,
            prodSubCat,
            prodCat,
            prodSup,
            cardType,
            isToggleOn,
            toSimulateProductonly,
            isExcelExport: false
        });
    }

    render() {
        const { key, cardType, containerWidth } = this.state;
        const { prod, prodBrand, prodSubCat, formValue, isRTL, loadingNow, prodCat, prodSup, isLoadingLambdaDataPanel } = this.props;

        const borderStyle = this.getBorderStyle(prod, cardType, formValue, prodBrand, prodSubCat, prodCat, prodSup, isRTL);
        const borderBottomStyle = this.getBorderBottomStyle(prod, cardType);

        return (
            <div key={key} className={"data-panel-item-card prod-item"} style={borderBottomStyle}>
                    <div className="first-col" style={{flex: cardType === "product" ? 1.8 : 1.5}}>
                        {cardType === 'product' ? (
                            <div className="product-by-face">
                                {/* {
                                prod.isDeletedSimProdForDataPanel ?
                                <div className={(this.props.isRTL === "rtl" ? "thumb-div-left" : "thumb-div-right")} onClick={() => this.props.handlePreviewModal(prod, true)}>
                                    <img key={key} src={prod?.imageUrl} className={(prod?.width >= prod?.height) ? "img-resize-ver" : "img-resize-hor"} alt="" />
                                </div>
                                :  */}
                                <div className={(this.props.isRTL === "rtl" ? "thumb-div-left" : "thumb-div-right")} onClick={() => this.props.handlePreviewModal(prod, true)} draggable id={prod?.id} onMouseDown={(e) => { this.props.drawRectCanvas(prod) }} onDragStart={(e) => this.props.dragStart(e, prod)} onDrag={e => this.props.dragProdView(e, prod)} onDragEnd={() => this.handleDragEnd()}>
                                    <img key={key} src={prod?.imageUrl} className={(prod?.width >= prod?.height) ? "img-resize-ver" : "img-resize-hor"} alt="" />
                                </div>
                                {/* } */}

                                <div className={(this.props.isRTL === "rtl" ? "item-desc-left" : "item-desc-right")} style={{ cursor: "pointer" }}>
                                    
                                         {/* <CopyToClipboard text={(prod.barcode ? prod.barcode : "-")} onCopy={() => this.props.copyToClipboard()}> */}
                                         <OverlayTrigger
                                            placement={this.props.isRTL === 'rtl' ? 'left' : 'right'}
                                            overlay={
                                                <Tooltip id={`tooltip-${prod?.id}`} dir={this.props.isRTL === "rtl" ? "rtl" : "ltr"} style={{ fontSize: '11px' }}>
                                                    {prod?.barcode ? prod?.barcode : "-"} <br />
                                                    {prod?.name ? prod?.name : "-"} <br />
                                                    {(prod?.brand?.brandName ? prod?.brand?.brandName : "-")
                                                        ? (prod?.brand?.brandName + " ")
                                                        : (this.props.t("notavailable") + " ")} 
                                                </Tooltip>
                                            }
                                        >
                                            <span
                                                className="text-color-dark hover-color-change"
                                                onClick={() => this.props.handleopenDetailmodal(prod)}
                                                style={{
                                                    wordBreak: "break-all",
                                                    whiteSpace: "pre-line",
                                                    paddingRight: this.props.isRTL === "rtl" ? 0 : 5,
                                                    paddingLeft: this.props.isRTL === "rtl" ? 5 : 0
                                                }}
                                            >
                                                {prod?.barcode ? prod.barcode : "-"}
                                            </span>
                                        </OverlayTrigger>
                                        {/* </CopyToClipboard> */}
                                            
                                        {/* <OverlayTrigger
                                            placement={this.props.isRTL === "rtl" ? "left" : "right"}
                                            overlay={
                                                <Tooltip id={`tooltip-${prod?.id}`} dir={this.props.isRTL === "rtl" ? "rtl" : "ltr"} style={{ fontSize: '11px' }}>
                                                    {prod?.barcode ? prod?.barcode : "-"} <br />
                                                    {prod?.name ? prod?.name : "-"} <br />
                                                    {(prod?.brand?.brandName ? prod?.brand?.brandName : "-")
                                                        ? (prod?.brand?.brandName + " ")
                                                        : (this.props.t("notavailable") + " ")} 
                                                </Tooltip>
                                            }
                                        >

                                            <span onClick={() => this.props.handleopenDetailmodal(prod)} style={{ color: 'rgba(177, 174, 174, 1)' }}>{prod?.name}</span>
                                        </OverlayTrigger> */}
                                    

                                            
                                            
                                            <small style={{ color: 'rgba(177, 174, 174, 1)' }}>
                                                {prod?.brand?.name || prod?.brand?.brandName || prod?.name || this.props.t("notavailable")}
                                            </small>
                                        
                                    
                                </div>
                            </div>
                        ) : cardType === 'brand' ? (
                            <div className={(this.props.isRTL === "rtl" ? "item-desc-only-left-brand" : "item-desc-only-right-brand")} style={{ cursor: "pointer" }}>
                                <OverlayTrigger
                                    placement={this.props.isRTL === "rtl" ? "left" : "right"}
                                    overlay={
                                        <Tooltip id={`tooltip-${prod?.id}`} dir={this.props.isRTL === "rtl" ? "rtl" : "ltr"} style={{ fontSize: '11px' }}>
                                            {prodBrand?.brand?.brandid ? prodBrand?.brand?.brandid : "-"}<br />
                                            {prodBrand?.brand?.brandName ? prodBrand?.brand?.brandName : "-"} 
                                        </Tooltip>
                                    }
                                >
                            
                                    <span className="text-color-dark">
                                        {prodBrand?.brand?.brandName ? (prodBrand?.brand?.brandName.length > 40 ? `${prodBrand?.brand?.brandName.substring(0, 40)}...` : prodBrand?.brand?.brandName) : "-"}<br />
                                        ({prodBrand?.subCat?.subCategoryName ? prodBrand?.subCat?.subCategoryName : "-"} )
                                    </span>
                                </OverlayTrigger>

                            </div>
                        ) : cardType === 'supplier' ? (
                            <div className={(this.props.isRTL === "rtl" ? "item-desc-only-left-brand" : "item-desc-only-right-brand")} style={{ cursor: "pointer" }}>
                                <OverlayTrigger
                                    placement={this.props.isRTL === "rtl" ? "left" : "right"}
                                    overlay={
                                        <Tooltip id={`tooltip-${prodSup?.id}`} dir={this.props.isRTL === "rtl" ? "rtl" : "ltr"} style={{ fontSize: '11px' }}>
                                            {prodSup?.supplier?.supplierId ? prodSup?.supplier?.supplierId : "-"}<br />
                                            {prodSup?.supplier?.supplierName ? prodSup?.supplier?.supplierName : "-"} 
                                        </Tooltip>
                                    }
                                >
                                    <span className="text-color-dark">
                                        {prodSup?.supplier?.supplierName ? (prodSup?.supplier?.supplierName.length > 40 ? `${prodSup?.supplier?.supplierName.substring(0, 40)}...` : prodSup?.supplier?.supplierName) : "-"}<br />
                                        ({prodSup?.subCat?.subCategoryName ? prodSup?.subCat?.subCategoryName : "-"} )
                                    </span>
                                </OverlayTrigger>
                            </div>
                        ) : cardType === 'category' ? (
                            <div className={(this.props.isRTL === "rtl" ? "item-desc-only-left-sub-category" : "item-desc-only-right-sub-category")} style={{ cursor: "pointer" }}>
                                <span className="text-color-dark">{prodCat?.categoryId ? prodCat?.categoryId : "-"}<br /></span>
                                <OverlayTrigger
                                    placement={this.props.isRTL === "rtl" ? "left" : "right"}
                                    overlay={
                                        <Tooltip id={`tooltip-${prodCat?.id}`} dir={this.props.isRTL === "rtl" ? "rtl" : "ltr"} style={{ fontSize: '11px' }}>
                                            {prodCat?.categoryId ? prodCat?.categoryId : "-"} <br />
                                            {prodCat?.categoryName ? prodCat?.categoryName : "-"} 
                                        </Tooltip>
                                    }
                                >
        
                                    <span className="text-color-dark">{prodCat?.categoryName ? prodCat?.categoryName : "-"}</span >
                                </OverlayTrigger>
                            </div>
                        ) : cardType === 'sub-category' ? (
                            <div className={(this.props.isRTL === "rtl" ? "item-desc-only-left-sub-category" : "item-desc-only-right-sub-category")} style={{ cursor: "pointer" }}>
                                <span className="text-color-dark"> {prodSubCat?.subCat?.subCategoryid ? prodSubCat?.subCat?.subCategoryid : "-"} <br /></span>
                                <OverlayTrigger
                                    placement={this.props.isRTL === "rtl" ? "left" : "right"}
                                    overlay={
                                        <Tooltip id={`tooltip-${prod?.id}`} dir={this.props.isRTL === "rtl" ? "rtl" : "ltr"} style={{ fontSize: '11px' }}>
                                            {prodSubCat?.subCat?.subCategoryid ? prodSubCat?.subCat?.subCategoryid : "-"} <br />
                                            {prodSubCat?.subCat?.subCategoryName ? prodSubCat?.subCat?.subCategoryName : "-"} 
                                        </Tooltip>
                                    }
                                >

                                    <span className="text-color-dark">{prodSubCat?.subCat?.subCategoryName ? prodSubCat?.subCat?.subCategoryName : "-"}</span >
                                </OverlayTrigger>
                            </div>
                        ) : null}
                    </div>
                    {this.props.filterSelections && this.props.filterSelections.map((filter, idx) => (
                        <OverlayTrigger
                            placement={this.props.isRTL === "rtl" ? idx < 1 ? "left" : "right" : idx < 1 ? "right" : "left"}
                            overlay={
                                <Tooltip id={`tooltip-${filter.short}`} dir={this.props.isRTL === "rtl" ? "rtl" : "ltr"} style={{ fontSize: '11px' }}>
                                    {this.getLambdaDataValue(filter)}
                                </Tooltip>
                            }
                        >

                            <div key={filter.short || idx} className="filter-col"
                                style={{ flex: 1 }}>
                                {this.getLambdaDataValue(filter)}
                            </div>
                        </OverlayTrigger>
                    ))}
                    <div className="last-col" style={{
                        ...borderStyle,
                        flex: 1,
                        // textAlign: this.props.isRTL === "rtl" ? "left" : "right",
                        paddingRight: this.props.isRTL === "rtl" ? 0 : 2,
                        paddingLeft: this.props.isRTL === "rtl" ? 2 : 0
                    }}>
                        {prod?.category === "non-simulated" && cardType === 'product' ? (
                            <>
                                <div>
                                    <small className="text-color-dark">
                                        {this.renderNowRecValues(
                                            prod?.now !== undefined && prod?.now !== null
                                                ? Number.isInteger(prod.now)
                                                    ? 0
                                                    : typeof prod.now === 'number' ? prod.now.toFixed(2) : prod.now
                                                : prodBrand?.brandNow !== undefined && prodBrand?.brandNow !== null
                                                ? Number.isInteger(prodBrand.brandNow)
                                                    ? prodBrand.brandNow
                                                    : typeof prodBrand.brandNow === 'number' ? prodBrand.brandNow.toFixed(2) : prodBrand.brandNow
                                                : 0,
                                            prod?.rec !== undefined && prod?.rec !== null
                                                ? Number.isInteger(prod.rec)
                                                    ? prod.rec
                                                    : typeof prod.rec === 'number' ? parseFloat(prod.rec.toFixed(2)) : prod.rec
                                                : prodBrand?.brandRec !== undefined && prodBrand?.brandRec !== null
                                                ? Number.isInteger(prodBrand.brandRec)
                                                    ? prodBrand.brandRec
                                                    : typeof prodBrand.brandRec === 'number' ? prodBrand.brandRec.toFixed(2) : prodBrand.brandRec
                                                : prodSubCat?.subCatRec !== undefined && prodSubCat?.subCatRec !== null
                                                ? Number.isInteger(prodSubCat.subCatRec)
                                                    ? prodSubCat.subCatRec
                                                    : typeof prodSubCat.subCatRec === 'number' ? prodSubCat.subCatRec.toFixed(2) : prodSubCat.subCatRec
                                                : null
                                        )}
                                    </small>
                                </div>
                            </>
                        ) : cardType === 'product' ? (
                            <div>
                                <small className="text-color-dark-aui">
                                    {this.renderNowRecValues(
                                        prod?.now !== undefined && prod?.now !== null
                                            ? Number.isInteger(prod.now)
                                                ? prod.now
                                                : typeof prod.now === 'number' ? prod.now.toFixed(2) : prod.now
                                            : prodBrand?.brandNow !== undefined && prodBrand?.brandNow !== null
                                            ? Number.isInteger(prodBrand.brandNow)
                                                ? prodBrand.brandNow
                                                : typeof prodBrand.brandNow === 'number' ? prodBrand.brandNow.toFixed(2) : prodBrand.brandNow
                                            : prodSubCat?.subCatNow !== undefined && prodSubCat?.subCatNow !== null
                                            ? Number.isInteger(prodSubCat.subCatNow)
                                                ? prodSubCat.subCatNow
                                                : typeof prodSubCat.subCatNow === 'number' ? prodSubCat.subCatNow.toFixed(2) : prodSubCat.subCatNow
                                            : null,
                                        prod?.rec !== undefined && prod?.rec !== null
                                            ? Number.isInteger(prod.rec)
                                                ? prod.rec
                                                : typeof prod.rec === 'number' ? parseFloat(prod.rec.toFixed(2)) : prod.rec
                                            : prodBrand?.brandRec !== undefined && prodBrand?.brandRec !== null
                                            ? Number.isInteger(prodBrand.brandRec)
                                                ? prodBrand.brandRec
                                                : typeof prodBrand.brandRec === 'number' ? prodBrand.brandRec.toFixed(2) : prodBrand.brandRec
                                            : prodSubCat?.subCatRec !== undefined && prodSubCat?.subCatRec !== null
                                            ? Number.isInteger(prodSubCat.subCatRec)
                                                ? prodSubCat.subCatRec
                                                : typeof prodSubCat.subCatRec === 'number' ? prodSubCat.subCatRec.toFixed(2) : prodSubCat.subCatRec
                                            : null
                                    )}
                                </small>
                            </div>
                        )  : (
                            <>
                                {(loadingNow || isLoadingLambdaDataPanel) ? (
                                    <div className="v2-box-1">
                                        <small className="text-color-dark-aui">
                                            <SyncIcon size={12} className={`dpspinner ${isRTL === "rtl" ? 'rtl' : 'ltr'}`} />
                                        </small>
                                    </div>
                                ) : (
                                    <div>
                                        <small className="text-color-dark-aui">
                                            {this.renderNowRecValues(
                                                prod?.now !== undefined && prod?.now !== null
                                                    ? Number.isInteger(prod.now)
                                                        ? prod.now
                                                        : typeof prod.now === 'number' ? prod.now.toFixed(2) : prod.now
                                                    : prodBrand?.brandNow !== undefined && prodBrand?.brandNow !== null
                                                    ? Number.isInteger(prodBrand.brandNow)
                                                        ? prodBrand.brandNow
                                                        : typeof prodBrand.brandNow === 'number' ? prodBrand.brandNow.toFixed(2) : prodBrand.brandNow
                                                    : prodSubCat?.subCatNow !== undefined && prodSubCat?.subCatNow !== null
                                                    ? Number.isInteger(prodSubCat.subCatNow)
                                                        ? prodSubCat.subCatNow
                                                        : typeof prodSubCat.subCatNow === 'number' ? prodSubCat.subCatNow.toFixed(2) : prodSubCat.subCatNow
                                                    : (typeof prodCat !== 'undefined' && prodCat?.categoryNow !== undefined && prodCat?.categoryNow !== null)
                                                    ? Number.isInteger(prodCat.categoryNow)
                                                        ? prodCat.categoryNow
                                                        : typeof prodCat.categoryNow === 'number' ? prodCat.categoryNow.toFixed(2) : prodCat.categoryNow
                                                    : (prodSup?.supplierNow !== undefined && prodSup?.supplierNow !== null)
                                                    ? Number.isInteger(prodSup.supplierNow)
                                                        ? prodSup.supplierNow
                                                        : typeof prodSup.supplierNow === 'number' ? prodSup.supplierNow.toFixed(2) : prodSup.supplierNow
                                                    : null,
                                                prod?.rec !== undefined && prod?.rec !== null
                                                    ? Number.isInteger(prod.rec)
                                                        ? prod.rec
                                                        : typeof prod.rec === 'number' ? parseFloat(prod.rec.toFixed(2)) : prod.rec
                                                    : prodBrand?.brandRec !== undefined && prodBrand?.brandRec !== null
                                                    ? Number.isInteger(prodBrand.brandRec)
                                                        ? prodBrand.brandRec
                                                        : typeof prodBrand.brandRec === 'number' ? prodBrand.brandRec.toFixed(2) : prodBrand.brandRec
                                                    : prodSubCat?.subCatRec !== undefined && prodSubCat?.subCatRec !== null
                                                    ? Number.isInteger(prodSubCat.subCatRec)
                                                        ? prodSubCat.subCatRec
                                                        : typeof prodSubCat.subCatRec === 'number' ? prodSubCat.subCatRec.toFixed(2) : prodSubCat.subCatRec
                                                    : (typeof prodCat !== 'undefined' && prodCat?.categoryRec !== undefined && prodCat?.categoryRec !== null)
                                                    ? Number.isInteger(prodCat.categoryRec)
                                                        ? prodCat.categoryRec
                                                        : typeof prodCat.categoryRec === 'number' ? prodCat.categoryRec.toFixed(2) : prodCat.categoryRec
                                                    : (prodSup?.supplierRec !== undefined && prodSup?.supplierRec !== null)
                                                    ? Number.isInteger(prodSup.supplierRec)
                                                        ? prodSup.supplierRec
                                                        : typeof prodSup.supplierRec === 'number' ? prodSup.supplierRec.toFixed(2) : prodSup.supplierRec
                                                    : null
                                            )}
                                        </small>
                                    </div>
                                )}
                            </>
                        )}
                        {prod?.category === "non-simulated" && cardType === 'product' && (
                            <>
                                {prod?.notSimulatedReason === "noEnoughSpace" ? (
                                    <span title={this.props.t("NOT_ENOGH_SPACE")}> <CodeSquareIcon size={14} className={(isRTL === "rtl" ? "v2-code-square-icon-left" : "v2-code-square-icon-right")} /> </span>
                                ) : prod?.notSimulatedReason === "none" ? (
                                    <span title={this.props.t("NO_REASON")}> <FeatherIcon color="red" icon="slash" size={14} className={(isRTL === "rtl" ? "v2-code-square-icon-left" : "v2-code-square-icon-right")} /> </span>
                                ) : prod?.notSimulatedReason === "heightIssue" ? (
                                    <span title={this.props.t("HEIGHT_NOT_ENOUGH")}> <FeatherIcon color="red" icon="arrow-up-circle" size={14} className={(isRTL === "rtl" ? "v2-code-square-icon-left" : "v2-code-square-icon-right")} /> </span>
                                ) : prod?.notSimulatedReason === "noTagMatching" ? (
                                    <span title={this.props.t("NO_TAG_MATCHING")}> <FeatherIcon size={14} icon="tag" className={(isRTL === "rtl" ? "v2-code-square-icon-left" : "v2-code-square-icon-right")} /> </span>
                                ) : prod?.notSimulatedReason === "minQtyIssue" ? (
                                    <span style={{fontSize: '11px'}} className={(isRTL === "rtl" ? "v2-code-square-icon-left" : "v2-code-square-icon-right")} >Qyt</span>
                                ) : prod?.notSimulatedReason ? (
                                    <span title={prod.notSimulatedReason.replace(/_/g, ' ').replace(/^./, str => str.toUpperCase())}> <FeatherIcon color="red" icon="alert-circle" size={14} className={(isRTL === "rtl" ? "v2-code-square-icon-left" : "v2-code-square-icon-right")} /> </span>
                                ) : null}
                            </>
                        )}
                    </div>
            </div>
        )
    }
}

export default withTranslation()(withRouter(connect(null)(DataPanelItemCard)))